/**
 * TanStack-Query-Keys für Properties.
 * Zentral gehalten damit Invalidation in Mutations konsistent funktioniert.
 */
import type { QueryRequest } from '@/shared/api';

export const propertyKeys = {
  all: ['properties'] as const,
  lists: () => [...propertyKeys.all, 'list'] as const,
  list: (filters: QueryRequest) => [...propertyKeys.lists(), filters] as const,
  details: () => [...propertyKeys.all, 'detail'] as const,
  detail: (id: string) => [...propertyKeys.details(), id] as const,
};
